module.exports = __webpack_public_path__ + "img/sld_mfm_invs_6_dark.531268d8.svg";